import { Link } from 'react-router-dom';
import { User } from './icons';
import type { AuthUser } from '../types/api';

interface Props {
  user: AuthUser;
}

/**
 * 桌面端顶栏右侧的账户入口。
 *
 * 2026-09-23 从下拉菜单改为直达链接：原来点头像展开「身份行 / 个人中心 / 扫码登录电脑 / 退出」，
 * 但三项里只有「个人中心」是常用的，为它多加一次点击不划算。现在头像旁直接写「个人中心」，
 * 点击即跳 /profile；退出登录移到用户中心页内；扫码登录电脑本就是「用手机扫、登录电脑」的
 * 操作，桌面端给这个入口没有意义，已去掉（移动端顶栏与抽屉仍保留）。
 *
 * 头像首字取真实姓名；没有姓名则用 User 图标兜底 —— 纯数字 QQ 邮箱取首字符会变成「1」，无意义。
 */
export function UserMenu({ user }: Props) {
  const realName = user.realName?.trim() ?? '';
  const initial = realName ? realName[0] : '';

  return (
    <Link
      to="/profile"
      title={realName || user.email || '未绑定邮箱'}
      className="flex h-9 flex-shrink-0 items-center gap-1.5 rounded-full pl-1 pr-2.5 text-fg-muted transition-colors hover:bg-surface-muted hover:text-fg"
    >
      <span
        aria-hidden
        className="flex h-6 w-6 items-center justify-center rounded-full bg-navy-fill text-[12px] font-medium leading-none text-white"
      >
        {initial || <User className="h-3.5 w-3.5" />}
      </span>
      <span className="whitespace-nowrap text-[13px]">个人中心</span>
    </Link>
  );
}
